export default "__VITE_ASSET__DQZEkSA2__"